/**
 * 安全返回：第三方 OAuth 登录后历史栈可能含 Google/LINE 等页，
 * 此时跳过 router.back()，改走业务兜底路径。
 * @param {string} fallbackPath 无法安全后退时的兜底路由
 */
export function safeNavigateBack(fallbackPath) {
	if (!import.meta.client) {
		return navigateTo(fallbackPath);
	}

	if (sessionStorage.getItem("oauth_history_dirty") === "1") {
		sessionStorage.removeItem("oauth_history_dirty");
		return navigateTo(fallbackPath);
	}

	if (window.history.length > 1) {
		const router = useRouter();
		return router.back();
	}

	return navigateTo(fallbackPath);
}
